import * as React from 'react';
import { useCallback, useContext, useEffect, useRef } from 'react';
import classNames from 'classnames';
import { useDispatch, useSelector } from 'react-redux';
import * as _ from 'lodash';

import { ticketContactDataSelector } from '@/redux/app/selectors/ticket';
import { addContactTag } from '@/redux/app/actions/contact';
import { NavigationPaneRouteParamsContext } from '@/lib/navigation';
import { ContactTag, TagForm } from '../../../tag';

export interface TicketTagListProps {
  ticket: string;
  show?: boolean;
}

export const TicketTagList = React.forwardRef(({ ticket, show }: TicketTagListProps,
  ref: React.RefObject<any>) => {
  const { subdomain } = useContext(NavigationPaneRouteParamsContext);
  const contactData = useSelector(_.partial(ticketContactDataSelector, ticket));

  const dispatch = useDispatch();
  const addTag = useCallback((value: string) => {
    dispatch(addContactTag(subdomain, contactData.id, value));
  }, [subdomain, ticket, contactData?.id, dispatch]);
  const inputRef = useRef<HTMLInputElement>();
  const tags = contactData?.external_tags;
  useEffect(() => {
    if (show) {
      inputRef.current.focus();
    }
  }, [show]);

  return (
    <div id="tag-list-wrapper" ref={ref} className={classNames({ hide: !show })}>
      <div id="tag-list" className="list">
        {tags instanceof Array &&
          tags.filter(({ name }) => !!name)
            .map(({ name, color }) => (
              <ContactTag
                key={name}
                name={name}
                color={color}
                external
                subdomain={subdomain}
                contactId={contactData.id}
                removable
              />
            ))}
      </div>
      <TagForm ticket={ticket} handleSubmit={addTag} inputRef={inputRef} />
    </div>
  );
});
